import { sha256 } from 'js-sha256';
import { IManifest, ISegment, ISegmentPart, TPreloadSegment } from 'm3u8-parser';

import { PlaylistPostParseDecryptStage } from '@streamLoader/PlaylistDecrypt/PlaylistParsers/PlaylistPostParserDecrypt/PlaylistPostParseDecryptStage';

export class V1PostParseURLRestore extends PlaylistPostParseDecryptStage {
  private _cachedHash: Record<string, Uint8Array> = {};

  constructor() {
    super();
  }

  public restorePlaylist(data: IManifest, key: string): IManifest {
    data.segments = data.segments.map((segment) => this._restore(segment, key));
    if (data.preloadSegment?.parts?.length) {
      data.preloadSegment.parts = data.preloadSegment?.parts.map((part) => this._uriRestore<ISegmentPart>(part, key));
    }
    return data;
  }

  private _restore(segment: ISegment, key: string): ISegment {
    if (segment.parts) {
      segment.parts = segment.parts.map((part) => this._uriRestore<ISegmentPart>(part, key));
    }
    return this._uriRestore<ISegment>(segment, key);
  }

  private _uriRestore<T extends ISegment | ISegmentPart | TPreloadSegment>(segment: T, key: string): T {
    const reg: RegExp = /xxx_(.+)$/;
    const match: RegExpMatchArray | null = segment.uri.match(reg);

    if (!match) {
      return segment;
    }

    const encodedPart: string = match[1];

    const decodedStr: string = this._decode(encodedPart, key);

    if (segment.uri) {
      segment.uri = segment.uri.replace(reg, `${decodedStr}`);
    }

    return segment;
  }

  private _decode(uri: string, key: string): string {
    const decoder: TextDecoder = new TextDecoder('utf-8');

    const hash: Uint8Array = this._computeHash(key);
    const binaryResultString: string = atob(uri);

    const msgBuffer: Uint8Array = new Uint8Array(binaryResultString.length);

    for (let i: number = 0; i < binaryResultString.length; i++) {
      msgBuffer[i] = binaryResultString.charCodeAt(i) ^ hash[i % hash.length];
    }
    return decoder.decode(msgBuffer);
  }

  private _computeHash(key: string): Uint8Array {
    if (!this._cachedHash[key]) {
      const hashBuffer: ArrayBuffer = sha256.arrayBuffer(key);
      this._cachedHash[key] = new Uint8Array(hashBuffer);
    }
    return this._cachedHash[key];
  }
}
